"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = exports.SmallButton = exports.AskLink = exports.HelpBox = exports.HelpToggle = exports.Hint = exports.Meta = exports.Unit = exports.InputShell = exports.FieldHint = exports.FieldLabel = exports.Field = exports.Legend = exports.Fieldset = exports.PanelBody = exports.PanelTitle = exports.Panel = exports.ATTENTION_WASH = exports.ATTENTION = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
/**
 * Local primitives for the surplus calculator, built on the shared Ahti tokens.
 * Anything reusable beyond this tool belongs in common-styled-components instead.
 */
/** Amber, used wherever something needs the operator's attention but is not an error. */
exports.ATTENTION = "#E0A31F";
exports.ATTENTION_WASH = "#FDF4E3";
exports.Panel = styled_components_1.default.section `
  background: ${theme_1.theme.colors.white};
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  border-radius: 4px;
  margin-bottom: ${theme_1.theme.spacing(4)};
`;
exports.PanelTitle = styled_components_1.default.h3 `
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-1)};
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme_1.theme.colors.dimBlue};
  margin: 0;
  padding: ${theme_1.theme.spacing(2)} ${theme_1.theme.spacing(3)};
  border-bottom: 1px solid ${theme_1.theme.colors.grey(4)};
`;
exports.PanelBody = styled_components_1.default.div `
  padding: ${theme_1.theme.spacing(3)};
`;
exports.Fieldset = styled_components_1.default.fieldset `
  border: 0;
  margin: 0 0 ${theme_1.theme.spacing(3)};
  padding: 0;

  &:last-child {
    margin-bottom: ${theme_1.theme.spacing(0)};
  }
`;
exports.Legend = styled_components_1.default.legend `
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.darkBlue};
  padding: 0 0 ${theme_1.theme.spacing(1)};
`;
exports.Field = styled_components_1.default.div `
  display: grid;
  grid-template-columns: ${(p) => (p.$wide ? "1fr" : "1fr 118px")};
  align-items: center;
  gap: ${theme_1.theme.spacing(2)};
  padding: ${theme_1.theme.spacing(0)} 0;

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    grid-template-columns: ${(p) => (p.$wide ? "1fr" : "1fr 140px")};
    padding: ${theme_1.theme.spacing(1)} 0;
  }
`;
exports.FieldLabel = styled_components_1.default.label `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.blackText};
`;
exports.FieldHint = styled_components_1.default.small `
  display: block;
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
  line-height: 1.35;
`;
exports.InputShell = styled_components_1.default.div `
  display: flex;
  align-items: center;
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  border-radius: 4px;
  background: ${theme_1.theme.colors.white};
  transition: border-color 0.12s ease, box-shadow 0.12s ease;

  &:focus-within {
    border-color: ${theme_1.theme.colors.lightBlue};
    box-shadow: 0 0 0 3px rgba(34, 125, 254, 0.12);
  }

  input,
  select {
    width: 100%;
    min-width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    padding: ${theme_1.theme.spacing(1)} ${theme_1.theme.spacing(1)};
    ${theme_1.theme.fontNormal};
    ${theme_1.theme.fontSize(0)};
    color: ${theme_1.theme.colors.darkBlue};
    text-align: right;

    /*
     * iOS Safari zooms the whole page when a focused field is under 16px, and
     * never zooms back out. Bigger targets suit thumbs on small screens anyway.
     */
    @media (max-width: ${theme_1.breakpoints.tablet}px) {
      font-size: 16px;
      padding: ${theme_1.theme.spacing(2)} ${theme_1.theme.spacing(2)};
    }
  }

  select {
    text-align: left;
  }

  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
exports.Unit = styled_components_1.default.span `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.dimBlue};
  padding: 0 ${theme_1.theme.spacing(1)} 0 2px;
  white-space: nowrap;
`;
exports.Meta = styled_components_1.default.p `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
  line-height: 1.5;
  margin: 2px 0 ${theme_1.theme.spacing(1)};

  b {
    ${theme_1.theme.fontLabelBold};
    color: ${theme_1.theme.colors.darkBlue};
  }
`;
exports.Hint = styled_components_1.default.p `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
  margin: ${theme_1.theme.spacing(2)} 0 0;

  b {
    ${theme_1.theme.fontLabelBold};
    color: ${theme_1.theme.colors.darkBlue};
  }
`;
exports.HelpToggle = styled_components_1.default.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  border-radius: 50%;
  background: ${theme_1.theme.colors.white};
  color: ${theme_1.theme.colors.dimBlue};
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-3)};
  line-height: 1;
  cursor: pointer;
  padding: 0;
  margin-left: 5px;
  vertical-align: 1px;

  &:hover {
    border-color: ${theme_1.theme.colors.lightBlue};
    color: ${theme_1.theme.colors.lightBlue};
  }

  &[aria-expanded="true"] {
    background: ${theme_1.theme.colors.lightBlue};
    border-color: ${theme_1.theme.colors.lightBlue};
    color: ${theme_1.theme.colors.white};
  }

  &:focus-visible {
    outline: 2px solid ${theme_1.theme.colors.lightBlue};
    outline-offset: 2px;
  }
`;
exports.HelpBox = styled_components_1.default.div `
  background: ${theme_1.theme.colors.backgroundLightBlue};
  border-left: 2px solid ${theme_1.theme.colors.lightBlue};
  border-radius: 0 3px 3px 0;
  padding: ${theme_1.theme.spacing(2)};
  margin: 2px 0 ${theme_1.theme.spacing(2)};

  p {
    margin: 0;
    ${theme_1.theme.fontNormal};
    ${theme_1.theme.fontSize(0)};
    color: ${theme_1.theme.colors.dimBlue};
    line-height: 1.6;
  }
`;
exports.AskLink = styled_components_1.default.button `
  border: 0;
  background: none;
  padding: 0;
  margin-top: 7px;
  cursor: pointer;
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.blue};

  &:hover {
    text-decoration: underline;
  }
`;
exports.SmallButton = styled_components_1.default.button `
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  background: ${theme_1.theme.colors.white};
  border-radius: 4px;
  cursor: pointer;
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-3)};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${theme_1.theme.colors.dimBlue};
  padding: 7px 10px;
  white-space: nowrap;

  &:hover {
    border-color: ${theme_1.theme.colors.lightBlue};
    color: ${theme_1.theme.colors.lightBlue};
  }

  &:focus-visible {
    outline: 2px solid ${theme_1.theme.colors.lightBlue};
    outline-offset: 2px;
  }
`;
exports.Columns = styled_components_1.default.div `
  display: grid;
  grid-template-columns: minmax(0, 340px) minmax(0, 1fr);
  gap: ${theme_1.theme.spacing(4)};
  align-items: start;
  width: 100%;

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    grid-template-columns: 1fr;
  }
`;
